import styled from '@emotion/styled'
import Stepper from '@mui/material/Stepper'
import Button from '@mui/material/Button'

export const StepperContainer = styled('div')({
  flex: '1',
  marginTop: '0',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
})

export const FormContainer = styled('form')({
  flex: '1',
  display: 'flex',
  flexDirection: 'column',
})

export const StepperStyled = styled(Stepper)(({ theme }) => ({
  backgroundColor: 'transparent',
  paddingTop: '0px',
  paddingBottom: '0px',
  width: '60%',
  [theme.breakpoints.down('sm')]: {
    marginTop: '2rem',
    width: '100%',
  },
  [theme.breakpoints.only('xs')]: {
    fontSize: '0.5rem',
  },
}))

export const ButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  padding: '0',
  height: '3rem',
  marginTop: '2rem',
  marginBottom: '3rem',
  '& button:first-of-type': {
    marginRight: '2rem',
  },
})

export const StepsWrapper = styled('div')({
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  marginTop: '2rem',
  minHeight: '35vh',
})

export const ButtonStyle = styled(Button)({
  minWidth: '10rem',
})

export const FooterContainer = styled('div')(({ theme }) => ({
  margin: '0px',
  padding: '2rem',
  width: '100%',
  display: 'flex',
  backgroundColor: theme.palette.background,
  color: '#fff',
  marginTop: '1rem',
  position: 'relative',
  '& span': {
    background: '#fafafa',
    padding: '0 20px',
  },
}))
